import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import BarChart from "../Componants/BarChart";

export default function Dashboard() {
  const { data: dashBoardData, refetch, isLoading } = useQuery({
    queryKey: ["dashBoardData"], // Ensure re-fetch on changes
    queryFn: () => getRequest(`/dashboard/info`),
  });
  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3>Dashboard</h3>
            <Row>
              <Col lg={7}>
                <div className="activity-report-box">
                  <div className="activity-report-title">
                    <div>
                      <h4>Activity Report</h4>
                      <p>Weekly Overview</p>
                    </div>
               
                  </div>
                  <div className="leads-pre-box">
                    <div>
                      <h2>
                        {dashBoardData?.data?.totalLead} Leads 
                        {/* <span>+4.2%</span> */}
                      </h2>
                      <p>New Leads This Week</p>
                      {/* <p>+4.2% on last week</p> */}
                    </div>
                    {/* <img
                      src={require("../assets/images/dashboard-graph.png")}
                    /> */}
                      <BarChart data={dashBoardData?.data?.leadWeeklyInfo} />
                  </div>
                  <div className="activity-report-overview">
                    <div className="pesponses-activity">
                      <p>
                        <span></span>Responses
                      </p>
                      <h5 className="dashboard-statics">{dashBoardData?.data?.responses}</h5>
                    </div>
                     <div className="profile-views-activity">
                      <p>
                        <span></span>Profile Views
                      </p>
                      <h5 className="dashboard-statics">{dashBoardData?.data?.profileViews}</h5>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={5}>
                <div className="activity-report-box ">
                  <div className="activity-report-title">
                    <div>
                      <h4>Popular Services</h4>
                      <p>Most Popular Services Searched
                      by Customers</p>
                    </div>
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <circle
                        cx="11"
                        cy="11"
                        r="0.916667"
                        stroke="#2F2B3D"
                        strokeOpacity="0.4"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="11"
                        cy="17.4167"
                        r="0.916667"
                        stroke="#2F2B3D"
                        strokeOpacity="0.4"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <ellipse
                        cx="11"
                        cy="4.58329"
                        rx="0.916667"
                        ry="0.916667"
                        stroke="#2F2B3D"
                        strokeOpacity="0.4"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg> */}
                  </div>
                  <ul className="popular-services-list populer-min">
                    {Array.isArray(dashBoardData?.data?.services) && dashBoardData?.data?.services.length > 0 ?
                    <>
                      {dashBoardData?.data?.services.map((val) => {
                        return (
                          <li key={val?._id}>
                          <div className="popular-services-item">
                            <div>
                              <h4>{val?.serviceName}</h4>
                              <p>{val?.category?.categoryName}</p>
                            </div>
                            <p>{val?.totalSearch} Searches</p>
                          </div>
                        </li>
                        )
                      })}
                    </>
                    :
                    <h6>No Data Found</h6>
                  }

                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
